{
  "merchant": "nugs-production",
  "widevine": {
    "server": "https://lic.drmtoday.com/license-proxy-widevine/cenc/?specConform=true"
  },
  "playready": {
    "server": "https://lic.drmtoday.com/license-proxy-headerauth/drmtoday/RightsManager.asmx"
  },
  "fairplay": {
    "server": "https://lic.drmtoday.com/license-server-fairplay/",
    "cert": "https://lic.drmtoday.com/license-server-fairplay/cert/nugs-production"
  }
}
